import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/Common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BackupsTab } from "@/components/privacy/BackupsTab";
import { RetentionTab } from "@/components/privacy/RetentionTab";
import { RequestsTab } from "@/components/privacy/RequestsTab";

export default function Security() {
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState("backups");
  const [reqId, setReqId] = useState(null);
  useEffect(() => {
    const r = params.get("req"), t = params.get("tab");
    if (r) { setTab("requests"); setReqId(r); }
    else if (t) setTab(t);
    if (r || t) setParams({}, { replace: true });
  }, [params, setParams]);
  return (
    <div data-testid="security-page">
      <PageHeader eyebrow="Backup · GDPR · conservazione" title="Sicurezza e privacy" />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="backups" data-testid="security-tab-backups">Backup</TabsTrigger>
          <TabsTrigger value="requests" data-testid="security-tab-requests">Richieste privacy</TabsTrigger>
          <TabsTrigger value="retention" data-testid="security-tab-retention">Conservazione dati</TabsTrigger>
        </TabsList>
        <TabsContent value="backups"><BackupsTab /></TabsContent>
        <TabsContent value="requests"><RequestsTab initialId={reqId} onOpened={() => setReqId(null)} /></TabsContent>
        <TabsContent value="retention"><RetentionTab /></TabsContent>
      </Tabs>
      <p className="mt-6 text-xs text-muted-foreground">L'esportazione dei dati personali di un dipendente (art. 15 e 20 GDPR) si trova anche nella sua scheda in Personale. Ogni operazione resta nel registro modifiche.</p>
    </div>
  );
}
